import { createContext } from "react";

const PackagesContext = createContext({});

export default PackagesContext;
